import React from 'react';
import { useNavigate } from 'react-router-dom';
import  GetLangConfig  from '../../util/LangUtil';
import './preamble.css';
interface HandleError {
    handleError: Function;
}
export default function Preamble(props: HandleError) {
    const history = useNavigate();
    const langConfig = GetLangConfig('preamble');
    return (
        <div className="preamble-container">
            <h1 dangerouslySetInnerHTML={{ __html: langConfig.preamble.welcome }}></h1>
            <div className="header">
                <div>
                    <p>{langConfig.preamble.headerp1}</p>
                    <p>{langConfig.preamble.headerp2}</p>
                </div>
                <div>
                    <p>{langConfig.preamble.headerp3}</p>
                </div>
            </div>
            <div className="content">
                <div>
                    <div>1</div>
                    <p className="heading">{langConfig.preamble.contentq1p1}</p>
                    <p dangerouslySetInnerHTML={{ __html: langConfig.preamble.contentq1p2 }}></p>
                    <ul>
                        <li>{langConfig.general.policyPlan}</li>
                        <li>{langConfig.general.certificateNumber}</li>
                        <li>{langConfig.general.orgDealerName}</li>
                        <li>{langConfig.general.planMemberName}</li>
                    </ul>
                    <p dangerouslySetInnerHTML={{ __html: langConfig.preamble.contentq1p3 }}></p>
                </div>

                <div>
                    <div>2</div>
                    <p className="heading" dangerouslySetInnerHTML={{ __html: langConfig.preamble.contentq2p1 }}></p>
                    <p dangerouslySetInnerHTML={{ __html: langConfig.preamble.contentq2p2 }}></p>
                    <p dangerouslySetInnerHTML={{ __html: langConfig.preamble.contentq2p3 }}></p>
                </div>

                <div>
                    <div>3</div>
                    <p className="heading" dangerouslySetInnerHTML={{ __html: langConfig.preamble.contentq3p1 }}></p>
                    <p dangerouslySetInnerHTML={{ __html: langConfig.preamble.contentq3p2 }}></p>
                    <p dangerouslySetInnerHTML={{ __html: langConfig.preamble.contentq3p3 }}></p>
                </div>
                <div>
                    <div>4</div>
                    <p className="heading" dangerouslySetInnerHTML={{ __html: langConfig.preamble.contentq4p1 }}></p>
                    <p dangerouslySetInnerHTML={{ __html: langConfig.preamble.contentq4p2 }}></p>
                    <p dangerouslySetInnerHTML={{ __html: langConfig.preamble.contentq4p3 }}></p>
                    <p className="heading" dangerouslySetInnerHTML={{ __html: langConfig.preamble.contentq4p4 }}></p>
                    <ul>
                        <li>{langConfig.general.policyPlan}</li>
                        <li>{langConfig.general.certificateNumber}</li>
                        <li>{langConfig.general.orgDealerName}</li>
                        <li>{langConfig.general.planMemberName}</li>

                    </ul>
                </div>
            </div>
            <div>
                <button className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped " onClick={e=>history('/landing')}>
                    <div className="mdc-button__ripple"></div>
                    <span className="mdc-button__label">{langConfig.preamble.continueButton}</span>
                </button>
            </div>
        </div>
    );
}
